import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import InputLabel from "@mui/material/InputLabel";
import { Icon, Autocomplete } from "@mui/material";
import FormControl from "@mui/material/FormControl";

import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

import { Formik, ErrorMessage, Field, Form, } from 'formik';
import * as Yup from 'yup';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { connect } from "react-redux";
import { useEffect, useState } from "react";
import CustomSpinner from "layouts/ProgressBar";
import { Link, useNavigate } from "react-router-dom";

import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import Notification from "layouts/Notification";
import "./style.css"

import { getcommunitiesList, getCommunityStatistics } from "redux/actions/communityActions";
import { getChallengeStatisticsByOrganizer } from "redux/actions/challengeActions";

const reportType = [
  {
    id: 0,
    title: "Community Report"
  },
  {
    id: 1,
    title: "Challenge reports"
  }
]


function ReportForm({ userDetails, getcommunitiesList, getCommunityStatistics, getChallengeStatisticsByOrganizer,
  successReducer, communityListReducer, communityStatisReducer, challengeStatisticsByOrganizerReducer }) {

  const [communitiesList, setCommunitiesList] = useState([]);
  const [statisticsMonth, setStatisticsMonth] = useState(new Date());
  const [continuationtoken, setContinuationtoken] = useState(null);
  const [disabledNextBtn, setDisabledNextBtn] = useState(true);
  const [challengeStatisticsList, setChallengeStatisticsList] = useState([]);

  const navigate = useNavigate();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const formValidationSchema = {
    communityId: Yup.string().required("Please choose a community."),
    reportTypeId: Yup.string().required('Please choose report type.'),
  };

  const initialValues = {
    communityId: null,
    reportTypeId: null,
  }

  const [formInitialValues, setFormInitialValues] = useState(initialValues);

  useEffect(() => {
    getcommunitiesList();
    setIsLoading(true)
  }, []);

  useEffect(() => {
    if (communityListReducer?.communityList) {

      let tempData =
        communityListReducer.communityList.filter(x => x.type === 'Community').map((mainCom) => {
          return {
            id: mainCom?.community?.communityId,
            communityName: mainCom?.community?.communityName,
            communityProfileImageUrl: mainCom?.community?.communityProfileImageUrl
          };
        })

      setCommunitiesList(tempData);

      setFormInitialValues({
        communityId: null,
        reportTypeId: null,
      })
      setIsLoading(false);
    }
  }, [communityListReducer])

  useEffect(() => {
    if (challengeStatisticsByOrganizerReducer?.data) {

      let tempList = sessionStorage.getItem("challengeStatisticsList") ? JSON.parse(sessionStorage.getItem("challengeStatisticsList")) : [];
      tempList = [...tempList, ...challengeStatisticsByOrganizerReducer.data]
      sessionStorage.setItem("challengeStatisticsList", JSON.stringify(tempList));

      setContinuationtoken(challengeStatisticsByOrganizerReducer.continuationtoken)
      setChallengeStatisticsList(tempList)
    }
  }, [challengeStatisticsByOrganizerReducer])

  const resetFormData = (event, values) => {
    
    setFormInitialValues(
      {
        communityId: event === "communityId" ? values?.id : formInitialValues.communityId,
        reportTypeId: event === "reportTypeId" ? values?.id : formInitialValues.reportTypeId,
      }
    )
  }

  const onFormSubmit = (values, actions) => {

    if (values.reportTypeId === 0) {
      getMonthCommunityStatistics(statisticsMonth)
    }
    else {
      getChallengeStatisticsByOrganizer(values.communityId,)
    }
    sessionStorage.removeItem("challengeStatisticsList")
    // setIsLoading(false);
  }

  const getMonthCommunityStatistics = (currentMonth, nextMonth = false, previousMonth = false) => {

    let newDate = new Date(currentMonth);
    if (nextMonth) {
      newDate = new Date(newDate.setMonth(newDate.getMonth() + 1));
    } else if (previousMonth) {
      newDate = new Date(newDate.setMonth(newDate.getMonth() - 1));
    }

    let startDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1).toLocaleDateString();
    let endDate = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0).toLocaleDateString();
console.log('dasdas')
    let params = formInitialValues.communityId + "?startDate=" + startDate + "&endDate=" + endDate
    params = params.replaceAll('/', "%2F")
    setStatisticsMonth(startDate)
    getCommunityStatistics(params);
    setDisabledNextBtn(new Date(startDate).getFullYear() >= new Date().getFullYear() && new Date(startDate).getMonth() >= new Date().getMonth()  )

  }

  const getMonth = (month) => {
    return new Date(month).toLocaleString('default', { month: 'long' })
  }

  const checkDataIsCurrentMonth = (month) => {
    let today = new Date()
    let dateOfData = new Date(month)
    return today < dateOfData
  }
  const loadMoreChallengeStatistics = () => {
    if (continuationtoken) {
      getChallengeStatisticsByOrganizer(formInitialValues.communityId, { 'continuationtoken': continuationtoken })
    }
    else {
      getChallengeStatisticsByOrganizer(formInitialValues.communityId)
    }
  }


  return (
    <DashboardLayout>
      <DashboardNavbar absolute isMini />
      <MDBox mt={8}>
        <MDBox mx={0} mb={2} mt={3} py={3} px={2} variant="gradient" bgColor="success" borderRadius="lg" coloredShadow="info">
          <MDTypography variant="h6" color="white">
            Report
          </MDTypography>
        </MDBox>
        {isError && (
          <MDSnackbar
            color="error" icon="warning" title={isError} content={isError} open={isError} bgWhite
            onClose={() => { setIsError(false) }}
            close={() => { setIsError(false) }}
          />
        )}
        <MDBox mb={3}>
          {(communityListReducer?.loading || communityStatisReducer.loading || challengeStatisticsByOrganizerReducer.loading || isLoading) &&
            <CustomSpinner />
          }

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Formik
              enableReinitialize={true}
              initialValues={formInitialValues}
              validationSchema={Yup.object().shape(formValidationSchema)}
              onSubmit={onFormSubmit}
            >
              {formikProps => (
                <Form>
                  <Card>
                    <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }} py={3} px={2}>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Field
                            as={Autocomplete}
                            name="communityId"
                            options={communitiesList ? communitiesList : []}
                            defaultValue={formInitialValues.id}
                            value={formInitialValues.id}
                            onChange={(event, value) => {
                              resetFormData("communityId", value)
                            }}
                            getOptionLabel={(option) => option.communityName}
                            renderOption={(props, option) => (
                              <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} key={option.id}>

                                {option?.communityProfileImageUrl && option?.communityProfileImageUrl != ""
                                  ? <img
                                    srcSet={option.communityProfileImageUrl}
                                    src={option.communityProfileImageUrl}
                                    alt={option.communityName}
                                    className="communityImg"
                                  />
                                  : <Icon fontSize={"large"} className="communityImg communityImgIcon" >account_circle</Icon>
                                }
                                &nbsp;&nbsp;
                                <span>{option.communityName}</span>
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Communities"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: ''

                                }}
                              />
                            )}
                          />
                          <ErrorMessage name="communityId" component="div" className="error-message" />
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Field
                            as={Autocomplete}
                            name="reportTypeId"
                            options={reportType}
                            defaultValue={formInitialValues.id}
                            value={formInitialValues.id}
                            onChange={(event, value) => {
                              resetFormData("reportTypeId", value)
                            }}
                            getOptionLabel={(option) => option.title}
                            renderOption={(props, option) => (
                              <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} key={option.id}>
                                <span>{option.title}</span>
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Choose Report"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: ''

                                }}
                              />
                            )}
                          />
                          <ErrorMessage name="reportTypeId" component="div" className="error-message" />
                        </FormControl>
                      </Grid>
                    </Grid>
                    <MDBox display="flex" justifyContent="end" alignItems="center" mt={2} mb={2} mr={2} >
                      <MDButton type="submit" size="medium" color="success">Get Report</MDButton>
                      &nbsp;
                      <Link to="/dashboard">
                        <MDButton type="button" size="medium" color="error">Back</MDButton>
                      </Link>
                    </MDBox>
                  </Card>
                </Form>
              )}
            </Formik>
            {(communityStatisReducer.data || challengeStatisticsByOrganizerReducer.data) &&
              <MDBox mt={3}>
                <Card >
                  <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 3 }} py={3} px={2}>
                    <Grid item xs={12}>
                      {(communityStatisReducer.data && formInitialValues.reportTypeId === 0) &&
                        <> <MDBox display="flex" justifyContent="center" alignItems="center" mt={2} mb={2} mr={10} >
                          <MDButton type="button" size="medium" color="success"
                            onClick={() => getMonthCommunityStatistics(statisticsMonth, false, true)} mr={10}>
                            {'<'}
                          </MDButton>
                          <MDTypography variant="h6" px={3}> {getMonth(statisticsMonth) + " , " + new Date(statisticsMonth).getFullYear()}</MDTypography>
                          <MDButton type="button" size="medium" color="success"
                            onClick={() => getMonthCommunityStatistics(statisticsMonth, true, false)}
                            disabled={disabledNextBtn}
                          >
                            {'>'}
                          </MDButton>
                        </MDBox>

                          <table className="reports-table ">
                            <tbody>
                              <tr>
                                <td className="reports-td " colSpan="2">Total members </td>
                                <td className="reports-td ">{communityStatisReducer.data.totalMembers}</td>
                              </tr>
                              <tr>
                                <td className="reports-td " colSpan="2">Total Activities</td>
                                <td className="reports-td ">{communityStatisReducer.data.totalActivities}</td>
                              </tr>
                              <tr>
                                <td className="reports-td " colSpan="2">Avg Activities pr member</td>
                                <td className="reports-td ">{communityStatisReducer.data.avgActivityPerMember}</td>
                              </tr>
                              <tr>
                                <td className="reports-td " colSpan="2">Total activity time</td>
                                <td className="reports-td ">{communityStatisReducer.data.totalActivityTime}</td>
                              </tr>
                              <tr>
                                <td className="reports-td " colSpan="2">Avg Activity time pr member</td>
                                <td className="reports-td ">{communityStatisReducer.data.avgActivityTimePerMember}</td>
                              </tr>
                              <tr>
                                <td className="reports-td " colSpan="2">Total Distance</td>
                                <td className="reports-td ">{communityStatisReducer.data.totalDistance}</td>
                              </tr>
                              <tr>
                                <td className="reports-td " colSpan="2">Avg Distance pr member</td>
                                <td className="reports-td ">{communityStatisReducer.data.avgDistancePerMember}</td>
                              </tr>
                            </tbody>
                          </table>
                        </>
                      }

                      {(challengeStatisticsList && formInitialValues.reportTypeId === 1) &&
                        <>
                          <table className="reports-table ">
                            <tbody>
                              <tr>
                                <th className="reports-th ">Challenge Name</th>
                                <th className="reports-th ">Participants</th>
                                <th className="reports-th ">Participants completed</th>
                                <th className="reports-th ">% completed</th>
                                <th className="reports-th ">Top three activities</th>
                              </tr>
                              {challengeStatisticsList?.length > 0 &&
                                challengeStatisticsList.map(item =>
                                  <tr key={item.challengeName}>
                                    <td className="reports-td ">{item.challengeName}</td>
                                    <td className="reports-td ">{item.numberOfParticipants}</td>
                                    <td className="reports-td ">{item.participantsCompleted}</td>
                                    <td className="reports-td ">{item.percentageCompleted}</td>
                                    <td className="reports-td activities">
                                      {item?.registeredActivities?.length > 0 &&
                                        item.registeredActivities.map(activity =>
                                          <>
                                            <span>{activity.label}</span>
                                            <br />
                                          </>
                                        )}
                                    </td>
                                  </tr>
                                )}
                            </tbody>
                          </table>
                          {continuationtoken &&
                            <MDBox display="flex" justifyContent="center" alignItems="center" mt={2} mb={2} mr={2} >
                              <MDButton type="button" size="medium" color="success" onClick={loadMoreChallengeStatistics}>Load More</MDButton>
                            </MDBox>
                          }
                        </>
                      }
                    </Grid>
                  </Grid>
                </Card>
              </MDBox>
            }
          </LocalizationProvider>


        </MDBox>
      </MDBox >
      {
        successReducer?.message &&
        <Notification
          color="success"
          icon="check"
          title={successReducer.message}
          content={successReducer.Description}
          dateTime=""
        />
      }
      <Footer />
    </DashboardLayout >
  );
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.logedinUserReducer.userDetails,
    communityListReducer: state.communityListReducer,
    successReducer: state.successReducer,
    communityStatisReducer: state.communityStatisReducer,
    challengeStatisticsByOrganizerReducer: state.challengeStatisticsByOrganizerReducer,
  };
};

export default connect(mapStateToProps, {
  getcommunitiesList,
  getCommunityStatistics,
  getChallengeStatisticsByOrganizer,
})(ReportForm);